/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type PropertyApiResourceOccupancy = typeof PropertyApiResourceOccupancy[keyof typeof PropertyApiResourceOccupancy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyApiResourceOccupancy = {
  vacant: 'vacant',
  tenant_occupied: 'tenant_occupied',
  owner_occupied: 'owner_occupied',
} as const;
